import type { SiteGroupCopyDto } from "../../types/SiteGroupCopyDto";
import type { SiteGroupCopyEntity } from "../../types/SiteGroupCopyEntity";

export const SiteGroupCopyEntityToCopyDto = ({ ...rest }: Readonly<SiteGroupCopyEntity>): SiteGroupCopyDto => {
    return { ...rest };
};
